<template />

<script>
export default {
	name: "GameType",
	props: { type: Object },
	methods: {
		chooseType (type) {
			this.$emit("chooseType", type);
		},
	},
};
</script>

<style>

</style>
